import { createSafeContext } from '@/util';

import type { VPeriodSelectorContextValue } from './type';

const VPeriodSelectorContext = createSafeContext<
  VPeriodSelectorContextValue<boolean>
>(null, 'VPeriodSelectorContext');

export default VPeriodSelectorContext;
